import LoadingBackdrop from '@/components/Grid/LoadingBackdrop';
import { GridToolbarContainer } from '@mui/x-data-grid-pro';

interface IProps {
  loading: boolean;
  title: string;
}

const GridToolBar = ({ loading, title }: IProps) => {
  return (
    <>
      <GridToolbarContainer sx={{ padding: 0 }}>
        <div className='py-[24px] px-[30px] flex items-center justify-start relative w-full'>
          <span className='text-[20px] font-semibold'>{title}</span>
        </div>
        {loading ? <LoadingBackdrop /> : null}
      </GridToolbarContainer>
    </>
  );
};

export default GridToolBar;
